export const CZI_CONVERSION_DONE_NEXT_ANNOTATE_DATASET = 'czi-conversion-done-next-annotate-dataset';
export const CZI_CONVERSION_DONE_NEXT_SHARE_DATASET = 'czi-conversion-done-next-share-dataset';
export const CZI_CONVERSION_DONE_NEXT_ADD_IMAGES_TO_DATASET = 'czi-conversion-done-next-add-images-to-dataset';
export const CZI_CONVERSION_DONE_NEXT_START_TRAINING_WITH_DATASET = 'czi-conversion-done-next-start-training-with-dataset';
export const CZI_CONVERSION_REMOVED_FAILED_CONVERSION_FILE = 'czi-conversion-removed-failed-conversion-file';
export const CZI_CONVERSION_COMPLETED = 'czi-conversion-completed';
export const CZI_CONVERSION_RETRY = 'czi-conversion-retry';
